export const LINK: string = "Link";
export const DATE: string = "date";
export const DROPDOWN: string = "dropdown";
export const TEXT: string = "text";
export const NUMBER: string = "number";
export const RANGE: string = "range";
export const DATE_RANGE: string = "date range";
export const DOCUMENT_GENERATION: string = "document-generation";
export const CALL_CAMPAIGN: string = "call-campaign";
export const KNOW_BOT_CAMPAIGN: string = "knowl-bot-campaign";
export const CRAFT_AI_BOT_CAMPAIGN: string = "craft-ai-bot-campaign";
export const AMOUNT: string = "Amount";
export const PASSWORD_ROTATION_DURATION_IN_MS: number = 15552000000; // 180 days in ms
export const PASSWORD_ROTATION_REMINDER_DURATION_IN_MS: number = 14688000000; // 170 days in ms
export const ONE_DAY_MS: number = 86400000;
export const ONE_HOUR_MS: number = 3600000;
export const ONE_MINUTE_MS: number = 60000;
export const ONE_SECOND_MS: number = 1000;
export const updateableFields =["status","client_manager_username","agency_name","pin_code","workable_pin_code","loan_type","dpd_bucket"];
export const CURRENT_CALL_STATUS = {
  connected: "connected",
  picked: "picked",
};
export const CALL_OUTCOME = {
  normal: "NORMAL_CLEARING",
  blocked: "BLOCKED",
  notAnswered: "NO_ANSWER_TIME_EXCEEDED",
  switchedOff: "SWITCHED_OFF",
  wrongNumber: "WRONG_NUMBER",
  userRejected: "REJECTED_BY_USER",
  phoneDeclined: "DECLINED_BY_PHONE"
};
export const DISPOSITION_INPUT_TYPES = {
  audio: 'AUDIO',
  file: 'FILE',
  number: 'NUMBER',
  text: 'TEXT',
  date: 'DATE',
  dropdown: 'DROPDOWN'
};
export const FILE_TYPES = {
  image: 'image',
  pdf: 'pdf',
  unknown: 'unknown'
};
export const INTERACTION_MODES = ["Call", "Visit"];
export const INTERACTION_AUDIT_STATUSES = {
  pending: "Pending",
  completed: "Completed"
};
export const CAMPAIGN_TYPES = [
  { label: 'Document Generation', value: DOCUMENT_GENERATION },
  { label: 'Call Campaign', value: CALL_CAMPAIGN },
];